var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19a9 9 0 100-18 9 9 0 000 18z",
    stroke: "#4CA80D",
    strokeWidth: 1.5,
    strokeDasharray: 63
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "-63;0",
    dur: "500ms",
    repeatCount: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.063 9.814L8.8 12.812l5.137-5.624",
    stroke: "#4CA80D",
    strokeWidth: 1.5,
    strokeDasharray: 40
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "40;40",
    dur: "300ms",
    repeatCount: 1
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "40;0",
    begin: "300ms",
    dur: "1200ms",
    repeatCount: 1
  }))));
}
export default SvgSuccessCheck;